import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const FreeForm = createSvgIcon(
  <svg id="Layer_1" viewBox="0 0 48 48" x="0px" y="0px" version="1.1">
    <g id="freeform">
      <path id="Rectangle" d="M 46 4 v 39.1 H 2 V 4 H 46 Z M 45.5 4.5 h -43 v 38.1 h 43 V 4.5 Z" />
    </g>
  </svg>,
  'FreeForm'
);
